<template>
  <div class="byg" >
    <van-panel class="title_dtl" @click="goDetailFun">
      <template #header>
        <div class="order_row van-hairline--bottom">
          <div class="left">
            <img class="icon_users" src="@/assets/order/order-users.png" alt="">
            <span class="users">
              {{formData.nickname}} <span>{{formData.mobileNo}}</span>
            </span>
          </div>
        </div>
      </template>

      <div class="order_item">
        <div class="order_row goods">
          <div class="left">
            <!-- <span v-for="i in 3" class="code">8006959999</span> -->
            <span v-for="(item,i) in formData.productVos" class="code" v-if="i<3">
              商品货号
              {{item.goodCode}}
            </span>
          </div>
          <div class="right" style="overflow: hidden;" >
            <span class="text" style="float:left;margin-top:2px">
              共 {{formData.productVosCount}} 件
            </span>
            <img class="icon" src="@/assets/order/order-arrow.png" alt="">
          </div>
        </div>

        <div class="footer">
          <div class="left"></div>
          <div class="right" align="right">
            <span>共 <span class="code mini-code">{{formData.productVosCount}}</span> 件商品， 共计</span>
            <span class="code">￥<span class="max-code">{{formData.totalPriceCount[0]}}</span>.{{formData.totalPriceCount[1] || '00'}}</span>
          </div>
        </div>
      </div>

    </van-panel>

    <van-panel>
      <template #header></template>
      <div class="order_info van-hairline--bottom">
        <div class="order_row">
          <span class="label">销售单号：</span>
          <span class="value">{{formData.saleNum}}</span>
        </div>
        <div class="order_row">
          <span class="label">线下门店名称：</span>
          <span class="value">{{formData.storeName}}</span>
        </div>
        <div class="order_row">
          <span class="label">线下门店编号：</span>
          <span class="value">{{formData.storeCode}}</span>
        </div>
        <div class="order_row">
          <span class="label">{{formData.refundOrderId ? '退款' : '支付'}}渠道：</span>
          <span class="value">{{formData.refundOrderId ? formData.refundChannel : formData.payChannel}}</span>
        </div>

        <div class="order_row" v-if="!formData.refundOrderId">
          <span class="label">优惠券：</span>
          <span class="value red">{{formData.couponValue ? '-￥'+formData.couponValue : ''}}</span>
        </div>

        <div class="order_row">
          <span class="label">{{formData.refundOrderId ? '退款' : '支付'}}流水号：</span>
          <span class="value">{{formData.refundOrderId ? formData.thirdRefundNo : formData.thirdTradeNo}}</span>
        </div>
        <div class="order_row">
          <span class="label">{{formData.refundOrderId ? '退款' : '支付'}}时间：</span>
          <span class="value">{{formData.refundOrderId ? formData.refundSuccessTime : formData.paySuccessTime}}</span>
        </div>
      </div>
      <div class="footer">
        <div class="right" align="right">
          <span>{{formData.refundOrderId ? '退款' : '支付'}}金额</span>
          <span class="code address">￥<span class="max-code">{{formData.payAmountShow[0]}}</span>.{{formData.payAmountShow[1] || '00'}}</span>
        </div>
      </div>
    </van-panel>
  </div>
</template>
<script>
import http from "@/utils/axios";
export default {
  data() {
    return {
      url: "",
      formData: {
        productVos: [],
        payAmountShow: []
      }

    };
  },
  async mounted() {
    this.url = this.$route.query.pageType == 0 ? "/order/offline/appOrder/payList" : "/order/offline/appOrder/refundList"
    this.$loading.hide();
    this.getForm()
    console.log(this.$route.query);
  },

  methods: {
    getForm() {
      http({
        url: this.url,
        method: "post",
        parmes: {
          payOrderId: this.$route.query.payOrderId,
          refundOrderId: this.$route.query.refundOrderId
        }
      }).then(rps => {
        if (rps.code === 200) {
          this.error = false;
          this.isLoading = false;
          let data = {}
          if(this.$route.query.pageType == 0){
            data = rps.data
          }else{
            data = rps.data.list[0]
          }

          data.payAmountShow = data.refundOrderId ? String(data.refundAmount).split('.') : String(data.actualPayAmount).split('.')
          data.productVosCount = data.productVos.reduce(( num,obj )=>( num += obj.quantity ),0)
          data.totalPriceCount = String(data.productVos.reduce(( num,obj )=>( num += obj.totalPrice ),0).toFixed(2)).split('.')

          this.formData = data
        }
      }).catch(rps => {
              
        // let formData =  {
        //       mobileNo: "18666218625",
        //       nickname: "微信用户",
        //       payAmount: 0.01,
        //       payChannel: "XXPAY_WECHAT_JSAPI_8023",
        //       payOrderId: 13,
        //       saleNum: "s123452",
        //       storeCode: "stc12345",
        //       storeName: "stc12345",
        //       thirdTradeNo: "",
        //       productVos:[
        //         {
        //           actualPrice: 0.01,
        //           discountUnitPrice: 0.01,
        //           goodCode: "goodCode",
        //           goodName: "goodName",
        //           productId: 7,
        //           quantity: 2,
        //           totalPrice:0.03
        //         },
        //         {
        //           actualPrice: 0.01,
        //           discountUnitPrice: 0.01,
        //           goodCode: "1234567890qwe",
        //           goodName: "goodName",
        //           productId: 7,
        //           quantity: 2,
        //           totalPrice:0.2
        //         },
        //         {
        //           actualPrice: 0.01,
        //           discountUnitPrice: 0.01,
        //           goodCode: "goodCode",
        //           goodName: "goodName",
        //           productId: 7,
        //           quantity: 2,
        //           totalPrice:0.2
        //         },
                
        //       ]
        //     }
        //     formData.payAmountShow = formData.refundOrderId ? String(formData.refundAmount).split('.') : String(formData.payAmount).split('.')
        //     formData.productVosCount = formData.productVos.reduce(( num,obj )=>( num += obj.quantity ),0)
        //     formData.totalPriceCount = String(formData.productVos.reduce(( num,obj )=>( num += obj.totalPrice ),0).toFixed(2)).split('.')
        //     this.formData =    formData  

        this.error = true;
        this.isLoading = false;
      });
    },
    goDetailFun(id) {
      this.$router.push({
        path: "/orderBelowGoods",
        query: {
          pageType: this.$route.query.pageType,
          payOrderId: this.$route.query.payOrderId,
          refundOrderId: this.$route.query.refundOrderId
        }
      });
    },


  },

};
</script>
<style lang="less" scoped>
  .byg {
    background: #f7f7f7;
    padding: 20px 20px 0 20px;
    font-size: 16px;
    .van-cell-group {
      border-radius: 10px;
      // &::after {
      //   border: 0;
      // }
      // .van-cell {
      //   border-radius: 10px;
      // }
    }
    .icon_users {
      width: 40px;
      height: 40px;
    }

    .title_dtl {
      margin-bottom: 20px;
    }
    .order_row {
      padding: 20px 20px;
      font-size: 28px;
      display: flex;
      align-items: center;
      &::after {
        border-bottom: 2px solid #e1e1e1;
      }
      .icon {
        width: 29px;
        height: 29px;
      }
      .left {
        display: flex;
        flex: 1;
        font-size: 26px;
        align-items: center;
        font-weight: 500;
        overflow: hidden;
      }
      .right {
        font-weight: 500;
        box-sizing: border-box;
        padding-left: 10px;
        display: flex;
        align-items: center;
      }
      .users {
        margin-left: 12px;
        font-weight: 600;
        line-height: 36px;
        font-size: 28px;
      }
    }

    .order_item {
      .goods {
        .code {
          text-align: center;
          width: 120px;
          height: 120px;
          color: #333;
          border: 2px solid #f8d541;
          border-radius: 4px;  
          background: rgba(248, 213, 65, 0.2);
          padding: 23px 25px;
          font-size: 26px!important;
          line-height: 38px;
          display: flex;
          align-items: center;
          margin-right: 12px;
          word-break:break-all;
        }
        .text {
          line-height: 32px;
          color: #666;
          font-size: 20px;
        }
      }
    }
    .footer {
      padding: 25px;
      font-size: 26px;
      .code {
        font-weight: 600;
      }
      .mini-code {
        font-size: 24px;
      }
      .max-code {
        font-size: 32px;
      }
      .address {
        color: #ed3939;
        margin-right: 20px;
      }
    }
    .order_info {
      padding: 26px 0 10px 0;
      .label {
        color: #808080;
        font-weight: 400;
      }
      .value {
        color: #333;
        font-weight: 600;
      }
    }
  }
  .red{
    color: #ed3939;
  }
</style>
